export default __webpack_public_path__ + "static/media/star.77032f62.svg";